import React from 'react';
import cx from 'classnames';

export const BlankTarget = ({ text, href, classNames, children, ...props }) => {
    return href ? <a {...props} className={cx(classNames)} target="_blank" href={href} rel="noopener noreferrer">{text || children}</a> :
        <span {...props} className={cx(classNames)}>{text || children}</span>
};


// WEBPACK FOOTER //
// ./src/components/BlankTarget.js